import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

interface CompanyActionMenuProps {
  companyId: string;
  anchorEl: HTMLElement;
  handleClose: () => void;
}

const CompanyActionMenu: React.FC<CompanyActionMenuProps> = (
  {
    companyId, anchorEl, handleClose,
  },
) => {
  const navigate = useNavigate();
  const handleEditClicked = () => {
    navigate(`/company/${companyId}`);
  };
  const handleViewAllStoresClicked = () => {
    navigate(`/stores/?companyId=${companyId}`);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={handleClose}
    >
      <MenuItem id="edit-company-button" onClick={handleEditClicked}>{'Edit'}</MenuItem>
      <MenuItem id="view-all-stores-button" onClick={handleViewAllStoresClicked}>{'View All Stores'}</MenuItem>
    </Menu>
  );
};
export default CompanyActionMenu;
